import React from "react";
import { View, Pressable, ActivityIndicator, StyleSheet } from "react-native";
import DsModal from "@components/ds/DsModal";
import { C, RText } from "../theme";

/**
 * Centered confirm pop-up, pixel-matched to the mockup's "Map this TP to
 * Ramesh?" (§10 frame 10): 16px radius, 20px padding, optional icon circle,
 * 18px / 700 title, Cancel (outline) + confirm (filled) at 15px / 600.
 * Rendered inside a sheet it nests as a child modal, which iOS allows.
 */
const ConfirmPopup = ({
  visible,
  title,
  icon = null,
  children,
  confirmLabel,
  cancelLabel,
  confirmColor = C.red,
  onCancel,
  onConfirm,
  loading = false,
}) => (
  <DsModal
    visible={visible}
    onClose={onCancel}
    position={DsModal.POSITION.CENTER}
    scrim={C.scrim}
    contentStyle={styles.card}
  >
    {icon ? <View style={styles.icon}>{icon}</View> : null}
    <RText size={18} weight={700}>
      {title}
    </RText>
    {children ? <View style={styles.body}>{children}</View> : null}
    <View style={styles.buttons}>
      <Pressable
        testID="ds-routing-confirm-cancel"
        onPress={onCancel}
        disabled={loading}
        style={[styles.btn, styles.cancel]}
      >
        <RText size={15} weight={600}>
          {cancelLabel}
        </RText>
      </Pressable>
      <Pressable
        testID="ds-routing-confirm-ok"
        onPress={onConfirm}
        disabled={loading}
        style={[styles.btn, { backgroundColor: confirmColor }]}
      >
        {loading ? (
          <ActivityIndicator color="#FFFFFF" />
        ) : (
          <RText size={15} weight={600} color="#FFFFFF">
            {confirmLabel}
          </RText>
        )}
      </Pressable>
    </View>
  </DsModal>
);

export default ConfirmPopup;

const styles = StyleSheet.create({
  card: {
    backgroundColor: C.surface,
    borderRadius: 16,
    padding: 20,
    marginHorizontal: 26,
  },
  icon: {
    width: 46,
    height: 46,
    borderRadius: 23,
    backgroundColor: C.blueBg,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 12,
  },
  body: { marginTop: 12 },
  buttons: { flexDirection: "row", gap: 10, marginTop: 16 },
  btn: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 9,
    paddingVertical: 12,
    minHeight: 46,
  },
  cancel: {
    backgroundColor: C.surface,
    borderWidth: 1.5,
    borderColor: C.border,
  },
});
